// extracted by mini-css-extract-plugin
export default {"root":"CalendarDropdownContent_root__BY2i+"};